import nativeApi from '@/utils/native-api'

function setTitle(title) {
  document.title = title

  setTimeout(() => {
    nativeApi.invoke('updateTitle', {text: title})
  }, 100)
}

export default {
  methods: {
    setNavigationTitle(title = '高铁管家') {
      setTitle(title)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/setNavigationTitle.js